module.exports = __webpack_public_path__ + "static/why-choose-us-950ee8e2c60338aed5d54952c4732b51.png";